//const { get_tokens } = require('./get_tokens');
//const { createCodeVerifier, createCodeChallenge } = require('./pkce');
//const { createState } = require('./state');
const get_tokens = require('./get_tokens').default
const { createCodeVerifier, createCodeChallenge } = require('./pkce')
const { createState } = require("./state")
// const cookie = require('cookie');

// This method is NOT recommended for use in production systems.
const stateStore = new Map();

/**
 * Handles the OAuth flow and returns user data
 * @param {Object} params - The parameters object
 * @param {string} params.environment - The environment URL
 * @param {string} params.client_id - The client ID
 * @param {string} params.client_secret - The client secret
 * @param {string} params.redirect_url - The redirect URL
 * @param {Object} params.req - Express request object
 * @returns {Promise<Object>} User data object or redirect information
 * 
 */
 const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
 const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
 const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT; 
 const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;

// const secretKey = 'your_secret_key';

async function handleOAuthFlow({ environment, client_id, client_secret, redirect_url, req }) {
    try {
        let state;
        let codeVerifier;
        let codeChallenge;
              
        if (!req.code || !req.state) {
            if (req.state) {
                stateStore.delete(req.state);
                localStorage.removeItem(req.state);
            }

            codeVerifier = createCodeVerifier();
            codeChallenge = createCodeChallenge(codeVerifier);
            state = createState();
            
            // Store in both places for redundancy
            stateStore.set(state, codeVerifier);
            localStorage.setItem(state, codeVerifier);
            
           

            const authBaseURL = `${plugin_environment}/a/consumer/api/v0/oidc/auth`;
            const scopesParameterEncoded = `?scope=${encodeURIComponent('openid profile https://api.banno.com/consumer/auth/user.profile.readonly')}`;
            const responseTypeParameter = `&response_type=code`;
            const clientIdParameter = `&client_id=${plugin_client_id}`;
            const redirectUriParameterEncoded = `&redirect_uri=${encodeURIComponent(plugin_redirecturi)}`;
            const stateParameter = `&state=${state}`;

            const claims = {
                'https://api.banno.com/consumer/claim/institution_id': null,
                'https://api.banno.com/consumer/claim/customer_identifier': null
            };

            const claimsToRequest = {
                id_token: claims,
                userinfo: claims
            };

            const claimsParameterValue = encodeURIComponent(JSON.stringify(claimsToRequest));
            const claimsParameter = `&claims=${claimsParameterValue}`;
            const codeChallengeParameter = `&code_challenge=${codeChallenge}`;
            const codeChallengeMethodParameter = `&code_challenge_method=S256`;

            const authorizationURL = `${authBaseURL}${scopesParameterEncoded}${responseTypeParameter}${clientIdParameter}${redirectUriParameterEncoded}${stateParameter}${codeChallengeParameter}${codeChallengeMethodParameter}${claimsParameter}`;
            
            

            return {
                results: "REDIRECT",
                redirect_url: authorizationURL,
                state: state,
                code_verifier: codeVerifier
            };
        }

        state = req.state;
        
        
        // Try to get code verifier from both storage locations
        codeVerifier = stateStore.get(state) || localStorage.getItem(state);
        
        if (!codeVerifier) {
            
            throw new Error('Code verifier not found for state: ' + state);
        }

        
        const auth_code = req.code;
        
        if (!auth_code) {
            throw new Error('Authorization code is missing');
        }

        
        const my_tokens = await get_tokens(plugin_environment, plugin_client_id, plugin_client_secret, auth_code, plugin_redirecturi, codeVerifier);
        
        if (!my_tokens || !my_tokens.access_token || !my_tokens.id_token) {
            throw new Error('Invalid token response from server');
        }

        const { access_token, id_token } = my_tokens;

        // Clean up after successful token exchange
        stateStore.delete(state);
        localStorage.removeItem(state);

        const user_id = id_token.sub;
        const partialKey = 'customer_identifier';
        const fullKey = findKeyByPartialName(id_token, partialKey);    

        return {
            results: "OK",
            error: "",
            member_number: id_token[fullKey] || ""
        };
    } catch (error) {
        
        return {
            results: "ERROR",
            error: error.message,
            member_number: "",
            first_name: "",
            middle_name: "",
            last_name: "",
            user_type: "",
            user_name: "",
            phone_number: ""
        };
    }
}

function findKeyByPartialName(jsonData, partialKey) {
    for (const key in jsonData) {
        if (key.includes(partialKey)) {
            return key;
        }
    }
    return null;
}

module.exports = { handleOAuthFlow };